import { startTransition, useState } from 'react';

import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import helper from '@utils/helper'

export const useTaradeCoinDetail = ({ marketStore, coinCode }) => {
  const [data, setData] = useState(null);
  const fetchMarketSymbols = async () => {
    await marketStore.fullMarketSymbols();
  }
  useIsomorphicLayoutEffect(() => {
    startTransition(() => {
      coinCode && fetchMarketSymbols()
    })
  }, [coinCode])

  useIsomorphicLayoutEffect(() => {
    const coinDetail = helper.getCoinDetail(coinCode, marketStore.marketSymbols);
    setData(coinDetail)
  }, [marketStore.marketSymbols])

  return data
}
